import React, { useState, useEffect, useRef, useCallback, createContext, useContext } from 'react';
import Sidebar from '../sidebar';
import s from '../../assets/logo.jpg';
import { AxiosError } from 'axios';
import SearchBox from '../searchbox';
import api from '../../services/api';
import { toast } from 'react-toastify';
import { Modal } from 'react-bootstrap';
import { ptBR } from "@mui/material/locale";
import { useMediaQuery } from '@mui/system';
import { AiFillFire } from 'react-icons/ai';
import { ApiError } from '../../services/tipos';
import styled, { keyframes } from "styled-components";
import { BsFileEarmarkBarGraph } from "react-icons/bs";
import { Redirect, useHistory, useLocation } from 'react-router-dom';
import { Creators as AuthActions } from '../../store/reducer';
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { IoIosMenu, IoIosArrowDown, IoIosArrowUp } from 'react-icons/io';
import { IdEmpresaAdm, diasRestantes, obterVersao, parseDataBRParaDate } from '../../services/utilitarios';
import { MdDashboard, MdDiamond, MdHelpCenter, MdHistory, MdInventory, MdLanguage, MdOutlineAttachMoney, MdReport, MdReportGmailerrorred, MdSecurity, MdWhatsapp, MdPeople } from 'react-icons/md';
import { FaAppStore, FaBuilding, FaCalendarCheck, FaCar, FaCheckCircle, FaCog, FaCogs, FaFileContract, FaFileInvoice, FaFileInvoiceDollar, FaHandshake, FaList, FaMapMarkerAlt, FaMobile, FaMoneyBill, FaOilCan, FaRoute, FaRobot, FaTag, FaTimes, FaTools, FaTrafficLight, FaUniversity, FaUser, FaUserTie, FaVideo, FaSearchPlus, FaChartLine } from 'react-icons/fa';
import { filtrarMenu, podeAcessarRota } from '../../services/acesso';
import { ehPlanoGratuito, estaEmPeriodoDeTeste, expiraEm, obterDataCadastro, obterEhAdmin, obterIdTenent, obterNomeEmpresa, obterNomeUsuario, obterPossuiSite, onboardingPendente, usuarioTemPermissao } from '../../services/seguranca';
import { NotificationBell } from "../notification-bell"
import { useNotifications } from '../../store/useNotifications';
import { MobileAppBanner } from '../mobile-app-banner';
import { AppDownloadAlert } from '../app-download-alert';
import { EVENTO_ABRIR_PRIMEIROS_PASSOS, OnboardingChecklist, OrigemPrimeirosPassos } from '../onboarding-checklist/OnboardingChecklist';
import { PARAMETRO_PRIORIDADES } from '../../view/onboarding/ModalPrioridades';
import OfertasBlackFriday, { EVENTO_ABRIR_OFERTAS, SeloOfertasBlackFriday, ofertasVisiveis } from '../ofertas-black-friday';
import FilialSelector from '../filial-selector';
import { StepByStepGuide } from '../step-by-step-guide/StepByStepGuide';
import { TOUR_DEFINITIONS } from '../step-by-step-guide/tourDefinitions';
import type { GuideStep } from '../step-by-step-guide/StepByStepGuide';
import { FloatingHelpBot } from '../floating-help-bot';
import { InsightsProvider } from '../assistente/InsightsProvider';
import { AvatarAssistente } from '../assistente/AvatarAssistente';
import { BalaoProativo } from '../assistente/BalaoProativo';
import { BotaoImplantacao } from '../botao-implantacao';
import logoLocaSmartCheck from '../../assets/logo-locasmartcheck.png';
import TabBar from '../tab-bar';

interface LocaSmartLayoutProps {
  children: React.ReactNode;
}

// Renderiza a chrome (sidebar/header/tabbar) UMA unica vez. Quando um <LocaSmartLayout>
// e aninhado dentro de outro (as paginas ainda trazem seu proprio <LocaSmartLayout>),
// o de dentro vira pass-through (so renderiza children), evitando duplicar a chrome
// dentro do subtree de keep-alive das abas — que era a causa da lentidao na troca.
export const LayoutMountedContext = createContext(false);

const rotateDown = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(180deg);
  }
`;

const rotateUp = keyframes`
  from {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(0deg);
  }
`;

const ContentWrapper = styled.div<{ mostrarAvisos: boolean }>`
  overflow-y: auto;
  height: 100%;
  /* Ancora as abas inativas (cachedRouteBehavior usa position:absolute p/ esconder
     fora de tela sem display:none e manter o grid sempre medido com tamanho real). */
  position: relative;
  .grid-container-normal {
    height: ${({ mostrarAvisos }) => (mostrarAvisos ? "680px" : "750px")};
    transition: height 0.3s ease;
  }

  .grid-container {
    height: ${({ mostrarAvisos }) => (mostrarAvisos ? "680px" : "750px")};
    transition: height 0.3s ease;
  }
`;

const LayoutContainer = styled.div`
  display: flex;
  height: 100vh;
  width: 100%;
`;

const SidebarContainer = styled.div`
  flex-shrink: 0;
  height: 100%;
`;

const ContentContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  transition: margin-left 0.3s;
  overflow: auto;
`;

const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
`;

const HeaderRight = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  gap: 2px;
`;

const ArrowIcon = styled.div<{ isOpen: boolean }>`
  margin-left: 8px;
  display: flex;
  align-items: center;
  animation: ${({ isOpen }) => isOpen ? rotateDown : rotateUp} 0.3s ease forwards;
`;

const AccountButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 20px;
  transition: all 0.2s ease;
  font-weight: 500;
  color: #333;
  
  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }
  
  .avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: #4a6cf7;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-size: 16px;
  }

  @media (max-width: 600px) {
    padding: 6px;
    .avatar {
      width: 36px;
      height: 36px;
      font-size: 14px;
    }
  }
`;

const AccountDropdown = styled.div`
  position: fixed;
  top: 70px;
  right: 20px;
  width: 240px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 9999;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  
  .user-info {
    padding: 16px;
    border-bottom: 1px solid #f0f0f0;
    
    .name {
      font-weight: 600;
      font-size: 14px;
      margin-bottom: 4px;
    }
    
    .document {
      font-size: 12px;
      color: #666;
    }
  }
  
  .menu-item {
    padding: 12px 16px;
    font-size: 14px;
    color: #333;
    cursor: pointer;
    transition: all 0.2s ease;
    
    &:hover {
      background-color: #f8f9fa;
    }
    
    &:last-child {
      color: #dc3545;
    }
  }

  @media (max-width: 600px) {
    top: 60px;
    right: 10px;
    width: 200px;
  }
`;

const Header = styled.div<{ isVisible: boolean }>`
  background-color: white;
  height: ${({ isVisible }) => (isVisible ? '80px' : '0px')};
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${({ isVisible }) => (isVisible ? '0 20px' : '0')};
  overflow: hidden;
  transition: height 0.3s ease, padding 0.3s ease;
  position: relative;

  @media (max-width: 600px) {
    height: ${({ isVisible }) => (isVisible ? '60px' : '0px')};
    padding: ${({ isVisible }) => (isVisible ? '0 10px' : '0')};
  }
`;

const MenuToggle = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  font-size: 24px;
  color: #333;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  border-radius: 4px;
  transition: background-color 0.2s;

  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }

  @media (max-width: 600px) {
    font-size: 20px;
    padding: 6px;
  }
`;

const Footer = styled.div`
  height: 50px;
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  background-color: white;
  box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.1);
  flex-shrink: 0;
  width: 100%;

  @media (max-width: 600px) {
    height: 40px;
    font-size: 14px;
  }
`;

const NotificationBar = styled.div<{ isFreePlan: boolean }>`
  background-color: ${({ isFreePlan }) => isFreePlan ? 'rgba(220, 53, 69, 0.1)' : 'rgba(224, 240, 243, 0.6)'};
  color: ${({ isFreePlan }) => isFreePlan ? '#dc3545' : '#333'};
  padding: 10px 20px;
  font-size: 14px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 5px;
  margin: 10px;
  border: ${({ isFreePlan }) => isFreePlan ? '1px solid #dc3545' : 'none'};

  button {
    background: none;
    border: none;
    font-size: 16px;
    cursor: pointer;
    color: ${({ isFreePlan }) => isFreePlan ? '#dc3545' : '#333'};
  }

  h5 {
    color: ${({ isFreePlan }) => isFreePlan ? '#dc3545' : '#17A2B8'};
    margin: 0 0 5px 0;
  }

  span {
    color: ${({ isFreePlan }) => isFreePlan ? '#dc3545' : '#17A2B8'};
    font-weight: lighter;
  }

  a {
    color: ${({ isFreePlan }) => isFreePlan ? '#dc3545' : '#17A2B8'};
    font-weight: bold;
    text-decoration: none;
    margin-left: 5px;
  }

  @media (max-width: 600px) {
    padding: 8px 12px;
    font-size: 12px;
    margin: 8px;
    
    h5 {
      font-size: 14px;
    }
  }
`;

const PulseButton = styled.button`
  background-color: #dc3545;
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  animation: pulse 1.5s infinite;
  margin-left: 10px;

  &:hover {
    background-color: #c82333;
  }

  @keyframes pulse {
    0% {
      transform: scale(1);
      box-shadow: 0 0 0 0 rgba(220, 53, 69, 0.7);
    }
    70% {
      transform: scale(1.05);
      box-shadow: 0 0 0 10px rgba(220, 53, 69, 0);
    }
    100% {
      transform: scale(1);
      box-shadow: 0 0 0 0 rgba(220, 53, 69, 0);
    }
  }

  @media (max-width: 600px) {
    padding: 4px 8px;
    font-size: 11px;
    margin-left: 6px;
  }
`;

const ContingencyBanner = styled.div`
  background-color: #dc2626;
  color: #fff;
  padding: 14px 20px;
  font-size: 14px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 5px;
  margin: 10px;
  box-shadow: 0 2px 10px rgba(220, 38, 38, 0.45);

  h5 {
    color: #fff;
    margin: 0 0 5px 0;
  }

  span {
    color: #fee2e2;
    font-weight: normal;
  }

  @media (max-width: 600px) {
    padding: 8px 12px;
    font-size: 12px;
    margin: 8px;
    flex-direction: column;
    gap: 8px;

    h5 {
      font-size: 14px;
    }
  }
`;

const ContingencyPayButton = styled.button`
  background-color: #fff;
  color: #dc2626;
  border: none;
  padding: 10px 22px;
  border-radius: 5px;
  font-weight: bold;
  font-size: 14px;
  cursor: pointer;
  white-space: nowrap;
  transition: transform 0.15s ease, box-shadow 0.15s ease;

  &:hover {
    transform: scale(1.05);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
  }
`;

const ModalContent = styled.div`
  text-align: center;
  padding: 20px;
  z-index: 10000;
  
  h2 {
    color: #dc3545;
    margin-bottom: 20px;
  }
  
  p {
    margin-bottom: 30px;
    font-size: 16px;
  }
  
  button {
    background-color: #dc3545;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 5px;
    font-size: 14px;
    cursor: pointer;
    transition: background-color 0.3s;
    
    &:hover {
      background-color: #c82333;
    }
  }

  @media (max-width: 600px) {
    padding: 15px;
    
    h2 {
      font-size: 20px;
      margin-bottom: 15px;
    }
    
    p {
      font-size: 14px;
      margin-bottom: 20px;
    }
    
    button {
      padding: 8px 16px;
      font-size: 13px;
    }
  }
`;

const TrainingButton = styled.button`
  background: none;
  border: 1px solid #1f467e;
  color: #1f467e;
  padding: 5px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
  transition: all 0.2s ease;
  margin-right: 6px;
  white-space: nowrap;
  flex-shrink: 0;

  &:hover {
    background-color: #1f467e;
    color: white;
  }

  @media (max-width: 900px) {
    font-size: 0;
    gap: 0;
    padding: 6px;

    svg { font-size: 14px; }
  }
`;

const TourButton = styled.button`
  background: linear-gradient(135deg, #1f467e, #2d6bc4);
  border: none;
  color: white;
  padding: 5px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all 0.3s ease;
  margin-right: 6px;
  box-shadow: 0 2px 8px rgba(31, 70, 126, 0.35);
  animation: pulseGlow 2s ease-in-out infinite;
  white-space: nowrap;
  flex-shrink: 0;

  &:hover {
    background: linear-gradient(135deg, #2d6bc4, #1f467e);
    box-shadow: 0 4px 12px rgba(31, 70, 126, 0.5);
    transform: translateY(-1px);
  }

  @keyframes pulseGlow {
    0%, 100% { box-shadow: 0 2px 8px rgba(31, 70, 126, 0.35); }
    50% { box-shadow: 0 2px 16px rgba(31, 70, 126, 0.6); }
  }

  @media (max-width: 900px) {
    font-size: 0;
    gap: 0;
    padding: 6px;

    svg { font-size: 14px; }
  }
`;

const AssistantHeaderButton = styled.button`
  background: linear-gradient(135deg, #1F467E 0%, #2d6bc4 100%);
  border: none;
  color: white;
  padding: 5px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
  transition: all 0.2s ease;
  margin-right: 6px;
  white-space: nowrap;
  flex-shrink: 0;

  &:hover {
    box-shadow: 0 2px 10px rgba(31, 70, 126, 0.4);
    transform: translateY(-1px);
  }

  @media (max-width: 900px) {
    font-size: 0;
    gap: 0;
    padding: 6px;

    svg { font-size: 14px; }
  }
`;

export function LocaSmartLayout({ children }: LocaSmartLayoutProps) {
  // Se ja existe uma chrome montada acima (App), este layout vira pass-through.
  const layoutAlreadyMounted = useContext(LayoutMountedContext);
  if (layoutAlreadyMounted) {
    return <>{children}</>;
  }
  return (
    <LayoutMountedContext.Provider value={true}>
      <LocaSmartLayoutChrome>{children}</LocaSmartLayoutChrome>
    </LayoutMountedContext.Provider>
  );
}

function LocaSmartLayoutChrome({ children }: LocaSmartLayoutProps) {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [accountDropdownOpen, setAccountDropdownOpen] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const [token] = useState<string>(useAppSelector(state => state.token));
  const empresaTemFiliais = useAppSelector(state => state.empresaTemFiliais) || false;
  const filialSelecionada = useAppSelector(state => state.filialSelecionada);
  const usuarioTemFilialAtribuida = !!filialSelecionada;
  const [isCadastroIncompleto, setIsCadastroIncompleto] = useState(false);
  const [telefoneEmpresa, setTelefoneEmpresa] = useState<string | null>(null);
  const [logado] = useState<boolean>(useAppSelector(state => state.logado));

  useEffect(() => {
    // O guia é do dono da conta (administrador). Funcionários da empresa usam o sistema normalmente:
    // sem permissão para criar locação, eles ficariam presos no guia.
    if (logado && obterEhAdmin(token) && onboardingPendente(token)) {
      history.replace('/onboarding');
    }
  }, [logado, token, location.pathname]);
  const [showFreePlanModal, setShowFreePlanModal] = useState(false);
  const { notifications, setNotifications } = useNotifications(obterIdTenent(token));
  const [showTrainingModal, setShowTrainingModal] = useState(false);

  const [tourActive, setTourActive] = useState(false);
  const [activeGuideSteps, setActiveGuideSteps] = useState<GuideStep[] | null>(null);
  const [locaSmartCheckIntegrado, setLocaSmartCheckIntegrado] = useState(false);

  const isFreePlan = ehPlanoGratuito(token);
  const isTrial = estaEmPeriodoDeTeste(token);
  const expirationDate = expiraEm(token);
  const emContingencia = useAppSelector(state => state.emContingencia);
  const diasRestantesContingencia = useAppSelector(state => state.diasRestantesContingencia);
  const bloqueadoPorInadimplencia = useAppSelector(state => state.bloqueadoPorInadimplencia);
  const faturasEmAtraso = useAppSelector(state => state.faturasEmAtraso);

  const contaMenosDe30Dias = (() => {
    try {
      const dataCadastroStr = obterDataCadastro(token);
      if (!dataCadastroStr) return false;
      const dataCadastro = parseDataBRParaDate(dataCadastroStr);
      if (!dataCadastro) return false;
      const diffTime = Math.abs(new Date().getTime() - dataCadastro.getTime());
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      return diffDays <= 30;
    } catch {
      return false;
    }
  })();

  const openTrainingPlaylist = () => {
    window.open('https://treinamento.locasmartpro.com.br/', '_blank');
  };

  // Quem abriu o "Primeiros Passos" (telemetria do teste). Já aberto, a primeira origem vale: o
  // "Explorar o Sistema" fecha as prioridades e a volta ao /home não vira "automatico".
  const [origemTour, setOrigemTour] = useState<OrigemPrimeirosPassos>('botao');
  const tourAtivoRef = useRef(false);
  tourAtivoRef.current = tourActive;
  const startTour = (origem: OrigemPrimeirosPassos = 'botao') => {
    if (!tourAtivoRef.current) setOrigemTour(origem);
    setTourActive(true);
  };

  // No plano de teste, o "Primeiros Passos" abre toda vez que a pessoa chega ao dashboard. Logo
  // depois do onboarding quem abre são as prioridades (?prioridades=true), e ele vem ao fechá-las.
  const pediuPrioridades = new URLSearchParams(location.search).get(PARAMETRO_PRIORIDADES) === 'true';
  useEffect(() => {
    if (location.pathname === '/home' && !pediuPrioridades && token && estaEmPeriodoDeTeste(token)) startTour('automatico');
  }, [location.pathname, pediuPrioridades, token]);

  useEffect(() => {
    const aoPedirAbrir = (e: Event) => startTour((e as CustomEvent<OrigemPrimeirosPassos>).detail || 'explorar');
    window.addEventListener(EVENTO_ABRIR_PRIMEIROS_PASSOS, aoPedirAbrir);
    return () => window.removeEventListener(EVENTO_ABRIR_PRIMEIROS_PASSOS, aoPedirAbrir);
  }, []);

  function tratarErro(error: AxiosError<ApiError>) {
    const errorMessage = error.response?.data?.Mensagem || 'Erro desconhecido';
    toast.error(`Não foi possível continuar a operação: ${errorMessage}`);
  }

  const handleLogout = () => {
    dispatch({ type: "LOG_OUT" });
    setTimeout(() => {
      window.location.href = "/";
    }, 250);
  };

  const fetchEmpresa = async () => {
    try {
      await new Promise((resolve) => setTimeout(resolve, 250));
      const response = await api.get(`Empresa/${obterIdTenent(token)}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      const isIncomplete = !response.data.cep;
      setIsCadastroIncompleto(isIncomplete);
      setTelefoneEmpresa(response.data.telefone ?? null);
      dispatch(AuthActions.setCadastroIncompleto(isIncomplete));
    } catch (error: any) {
      tratarErro(error);
    }
  };

  useEffect(() => {
    if (logado && token) {
      fetchEmpresa();

      const hasSeenModal = localStorage.getItem('hasSeenFreePlanModal') == 'false' ? false : true;
      if (isFreePlan && !hasSeenModal) {
        setShowFreePlanModal(true);
        localStorage.setItem('hasSeenFreePlanModal', 'true');
      }
    }
  }, [logado, token]);

  useEffect(() => {
    if (logado && token) {
      api.get('/LocaSmartCheck/Status')
        .then(res => setLocaSmartCheckIntegrado(res.data?.integrado === true))
        .catch(() => {});
    }
  }, [logado, token]);

  const diasParaExpirar = diasRestantes(expirationDate);

  const [avisos, setAvisos] = useState<React.ReactNode[]>(
    // O período de teste não tem mais banner: aparece como o selo "Plano de Teste" no menu.
    isTrial
      ? []
      : parseDataBRParaDate(expirationDate) && diasParaExpirar <= 10
        ? [
          <h5>Renove o seu Plano</h5>,
          <span>
            Você tem acesso à versão completa do sistema até {expirationDate}. Aproveite e renove o plano agora mesmo
            <a href='/renovar'> clicando aqui</a>
          </span>
        ]
        : isFreePlan
          ? [
            <h5>Acesso Limitado ao Sistema</h5>,
            <span>
              Você tem acesso à Versão Gratuita do sistema com recursos limitados. Aproveite e assine o plano agora mesmo
              <a href='/planos'> clicando aqui</a>
            </span>
          ]
          : []
  );

  const notificationRef = useRef<HTMLDivElement | null>(null);
  const accountDropdownRef = useRef<HTMLDivElement | null>(null);

  const [mostrarAvisos, setMostrarAvisos] = useState<boolean>(() => {
    const storedData = localStorage.getItem('notificationPreference');
    if (storedData) {
      const { token: storedToken, hideNotifications } = JSON.parse(storedData);
      if (storedToken === token) {
        return !hideNotifications;
      }
    }
    return avisos.length > 0;
  });

  const fecharCentralAvisos = () => {
    setAvisos([]);
    setMostrarAvisos(false);
    localStorage.setItem('notificationPreference', JSON.stringify({
      token,
      hideNotifications: true
    }));
  };

  const handleClearAllNotifications = () => {
    setNotifications([]);
  };

  const handleOutsideClick = useCallback((event: MouseEvent) => {
    if (notificationRef.current && !notificationRef.current.contains(event.target as Node)) {
      setShowNotifications(false);
    }
    if (accountDropdownRef.current && !accountDropdownRef.current.contains(event.target as Node)) {
      setAccountDropdownOpen(false);
    }
  }, []);

  useEffect(() => {
    if (showNotifications || accountDropdownOpen) {
      document.body.addEventListener("click", handleOutsideClick);
    } else {
      document.body.removeEventListener("click", handleOutsideClick);
    }

    return () => {
      document.body.removeEventListener("click", handleOutsideClick);
    };
  }, [showNotifications, accountDropdownOpen, handleOutsideClick]);

  useEffect(() => {
    const storedData = localStorage.getItem('notificationPreference');
    if (storedData) {
      const { token: storedToken } = JSON.parse(storedData);
      if (storedToken !== token) {
        setMostrarAvisos(avisos.length > 0);
        localStorage.setItem('notificationPreference', JSON.stringify({
          token,
          hideNotifications: false
        }));
      }
    } else {
      localStorage.setItem('notificationPreference', JSON.stringify({
        token,
        hideNotifications: false
      }));
    }
  }, [token, avisos.length]);

  // Detectar guia ativo do onboarding
  useEffect(() => {
    const guideKey = localStorage.getItem('locasmart_active_guide');
    if (guideKey && TOUR_DEFINITIONS[guideKey]) {
      // Pequeno delay para a pagina renderizar os elementos
      const timer = setTimeout(() => {
        setActiveGuideSteps(TOUR_DEFINITIONS[guideKey]);
      }, 500);
      return () => clearTimeout(timer);
    } else {
      setActiveGuideSteps(null);
    }
  }, [location.pathname]);

  const handleGuideComplete = () => {
    localStorage.removeItem('locasmart_active_guide');
    setActiveGuideSteps(null);
  };

  const handleGuideDismiss = () => {
    localStorage.removeItem('locasmart_active_guide');
    setActiveGuideSteps(null);
  };

  const theme = createTheme(
    {
      palette: {
        primary: {
          light: "#6F7376",
          main: "#7E8285",
          dark: "#777A7D",
        },
        secondary: {
          light: "#6F7376",
          main: "#7E8285",
          dark: "#777A7D",
        },
      },
      typography: {
        fontFamily: [
          "system-ui",
          "-apple-system",
          "Segoe UI",
          "Roboto",
          "Helvetica Neue",
          "Arial",
          "Noto Sans",
          "Liberation Sans",
          "sans-serif",
          "Apple Color Emoji",
          "Segoe UI Emoji",
          "Segoe UI Symbol",
          "Noto Color Emoji"
        ].join(","),
      },
    },
    ptBR,
  );

  const subItensCadastro = [
    {
      title: "Serviços", link: "/servico", icon: FaTools
    },
    {
      title: "Peças", link: "/peca", icon: FaCogs
    },
    {
      title: "Prestadores / Fornecedores", link: "/prestador-servico", icon: FaUserTie
    }
  ];

  if (usuarioTemPermissao(token, 'usuario_visualizar') || usuarioTemPermissao(token, 'usuario_novo')) {
    subItensCadastro.push({
      title: "Usuário", link: "/usuarios", icon: FaUser
    })
  }

  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  const toggleAccountDropdown = () => {
    setAccountDropdownOpen(!accountDropdownOpen);
  };

  const getInitials = (name: string) => {
    if (!name) return 'US';
    const names = name.split(' ');
    const iniciais = names.length > 1
      ? `${names[0][0]}${names[names.length - 1][0]}`.toUpperCase()
      : `${name.substring(0, 2)}`.toUpperCase();
    return !iniciais.includes("UNDEFINED") ? iniciais : name.substring(0, 2)
  };

  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const menu = [
    { icon: MdDashboard, title: "Dashboard", link: '/home' },
    {
      icon: FaCog, title: "Cadastros", subItems: [
        {
          title: "Manutenção", subItems: subItensCadastro, expansivel: true
        },
        {
          title: "Locação", subItems: [
            {
              title: "Veículos", link: "/veiculo", icon: FaCar
            },
            {
              title: "Locatários", link: "/locatarios", icon: FaUser
            },
            {
              title: "Contrato", link: "/modelo-contrato", icon: FaFileContract
            },
          ], expansivel: true
        },
        {
          title: "Financeiro", subItems: [
            {
              title: "Categorias", link: "/categoria", icon: FaTag
            },
            ...(usuarioTemPermissao(token, 'banco_visualizar') ? [{
              title: "Bancos", link: "/cadastros/financeiro/bancos", icon: FaUniversity
            }] : []),
          ], expansivel: true
        },
        ...(!usuarioTemFilialAtribuida ? [{
          title: "Unidades", link: "/filiais", icon: FaBuilding
        }] : []),
      ], expansivel: true
    },
    {
      icon: FaList, title: "Movimentos", subItems: [
        {
          title: "Operacional", subItems: [
            {
              title: "Locações", link: "/locacao", icon: FaHandshake
            },
            {
              title: "Vistoria", link: "/vistoria", icon: FaCheckCircle
            },
            {
              title: "Mapa de Veículos", link: "/mapa-veiculos", icon: FaMapMarkerAlt
            },
            ...(usuarioTemPermissao(token, 'gestao_risco_visualizar') ? [{
              title: "Gestão de Risco", link: "/gestao-risco", icon: MdSecurity
            }] : []),
            {
              title: "Manutenções", icon: FaTools, subItems: [
                { title: "Registrar Manutenção", link: "/manutencoes", icon: FaTools },
                { title: "Plano de Manutenção", link: "/plano-manutencao", icon: FaCalendarCheck },
                { title: "Troca de Óleo", link: "/troca-de-oleo", icon: FaOilCan },
                { title: "Estoque de Peças", link: "/estoque", icon: MdInventory },
              ], expansivel: true
            },
          ], expansivel: true
        },
        {
          title: "Financeiro", subItems: [
            {
              title: "Multa", link: "/multas", icon: FaFileInvoiceDollar
            },
            {
              title: "Pagamento", link: "/pagamento?Pendentes=true", icon: FaMoneyBill
            },
            {
              title: "Lançamento", link: "/lancamento", icon: FaFileInvoice
            },
            {
              title: "Notas Fiscais", link: "/notas-fiscais", icon: FaFileContract
            }
          ], expansivel: true
        },
      ], expansivel: true
    },
    {
      icon: BsFileEarmarkBarGraph, title: "Relatórios", subItems: [
        {
          title: "Geral", link: "/relatorio-geral", icon: FaCog
        },
        {
          title: "Financeiro", link: "/relatorio-financeiro", icon: MdOutlineAttachMoney
        },
        {
          title: "Auditoria", link: "/auditoria", icon: MdHistory
        }
      ], expansivel: true
    },
    {
      icon: MdPeople, title: "Afiliação", link: "/afiliacao", badge: "Novo"
    },
    ...(obterPossuiSite(token) ? [{
      icon: MdLanguage, title: "Meu Site", link: "/meu-site"
    }] : (obterIdTenent(token) != IdEmpresaAdm ? [{
      icon: MdLanguage, title: "Meu Site", link: "/meu-site", badge: "Novo"
    }] : [])),
    {
      icon: MdHelpCenter, title: "Central de Ajuda", link: "/ajuda"
    },
    {
      icon: MdWhatsapp, title: "Suporte", link: "/suporte"
    },
    {
      icon: MdDiamond, title: "Planos", link: "/planos", corDestaque: "#1E47A8"
    }
  ];

  if (obterIdTenent(token) == IdEmpresaAdm) {
    menu.push({
      icon: AiFillFire, title: "Cupom", link: "/cupom-rota-secret"
    })
    menu.push({
      icon: FaChartLine, title: "Pesquisas", link: "/pesquisas"
    })
  }

  return (
    <ThemeProvider theme={theme}>
      <InsightsProvider ativo={!!(logado && token)}>
      <MobileAppBanner />
      {
        ((!logado) && (!token))
          ? <Redirect to='/login/acessobloqueado' />
          : ''
      }
      {
        (useAppSelector(state => state.expirado))
          ? <Redirect to='/login' />
          : ''
      }
      {
        (bloqueadoPorInadimplencia && location.pathname !== '/renovar')
          ? <Redirect to='/renovar' />
          : ''
      }

      {/* Modal de plano gratuito */}
      <Modal show={showFreePlanModal} isOpen={showFreePlanModal} onClose={() => setShowFreePlanModal(false)}>
        <ModalContent>
          <h2>🚨 Atenção 🚨</h2>
          <p>Você está utilizando o <strong>plano gratuito</strong> com recursos <strong>limitados</strong>! Ative o seu plano para continuar com a utilização <strong>ilimitada da plataforma</strong></p>
          <button onClick={() => {
            setShowFreePlanModal(false);
            history.push('/planos');
          }}>
            Ativar o meu Plano
          </button>
        </ModalContent>
      </Modal>

      <LayoutContainer>
        <SidebarContainer>
          <Sidebar
            items={filtrarMenu(menu as any[], token)}
            logo={s}
            companyName={obterNomeEmpresa(token)}
            userName={obterNomeUsuario(token)}
            collapsed={sidebarCollapsed}
            children={children}
            onToggleCollapse={toggleSidebar}
            customButtons={filtrarMenu([
              {
                title: "Criar Locação",
                link: "/locacao?criar=true",
                icon: FaHandshake,
                dataTour: "quick-locacao"
              },
              {
                title: "Recebimentos",
                link: "/pagamento?Pendentes=true",
                icon: FaMoneyBill,
                dataTour: "quick-pagamento"
              },
              {
                title: "Mapa de Veículos",
                link: "/mapa-veiculos",
                icon: FaMapMarkerAlt
              },
              {
                title: "Manutenção",
                link: "/manutencoes",
                icon: FaTools
              },
              {
                title: "Multas",
                link: "/multas",
                icon: FaTrafficLight
              },
              {
                title: "Modelo de Contrato",
                link: "/modelo-contrato",
                icon: FaFileContract,
                dataTour: "quick-contrato"
              },
              {
                title: "Vistoria/Checklist",
                link: "/vistoria",
                icon: FaCheckCircle
              },
              {
                title: "Troca de óleo",
                link: "/troca-de-oleo",
                icon: FaOilCan
              },
              {
                title: "APP Do Locatário",
                link: "/app-locatario",
                icon: FaCogs
              }
            ], token).filter(b => b.link !== "/locacao?criar=true" || usuarioTemPermissao(token, 'locacao_novo'))} />

        </SidebarContainer>

        <ContentContainer>
          <Header isVisible={true}>
            <HeaderLeft>
              <MenuToggle onClick={toggleSidebar}>
                <IoIosMenu />
              </MenuToggle>
              {!isMobile && (
                <SearchBox
                  dataSource={[
                    { chave: 'locatario', link: '/locatarios', texto: 'Cadastros > Locação > Locatários' },
                    { chave: 'serviços', link: '/servico', texto: 'Cadastros > Manutenção > Serviços' },
                    { chave: 'veiculos', link: '/veiculo', texto: 'Cadastros > Locação > Veículos' },
                    { chave: 'prestador de serviço', link: '/prestador-servico', texto: 'Cadastros > Manutenção > Prestadores / Fornecedores' },
                    { chave: 'peças', link: '/peca', texto: 'Cadastros > Manutenção > Peças' },
                    { chave: 'Manutenções', link: '/manutencoes', texto: 'Movimentos > Operacional > Manutenções' },
                    { chave: 'plano de manutenção', link: '/plano-manutencao', texto: 'Movimentos > Operacional > Plano de Manutenção' },
                    { chave: 'mapa veículos rastreamento', link: '/mapa-veiculos', texto: 'Movimentos > Operacional > Mapa de Veículos' },
                    { chave: 'locações', link: '/locacao', texto: 'Movimentos > Operacional > Locações' },
                    { chave: 'estoque de peças', link: '/estoque', texto: 'Movimentos > Operacional > Estoque de Peças' },
                    { chave: 'pagamento', link: '/pagamento?Pendentes=true', texto: 'Movimentos > Financeiro > Pagamento' },
                    { chave: 'lançamento', link: '/lancamento', texto: 'Movimentos > Financeiro > Lançamento' },
                    { chave: 'multa', link: '/multas', texto: 'Movimentos > Financeiro > Multa' },
                    { chave: 'dashboard', link: '/home', texto: 'Dashboard' },
                    { chave: 'Manutenções realizadas', link: '/relatorio-geral', texto: 'Relatórios > Geral > Manutenções realizadas' },
                    { chave: 'locações', link: '/relatorio-geral', texto: 'Relatórios > Geral > Locações' },
                    { chave: 'despesas', link: '/relatorio-financeiro', texto: 'Relatórios > Financeiro > Despesas' },
                    { chave: 'receitas', link: '/relatorio-financeiro', texto: 'Relatórios > Financeiro > Receitas' },
                    { chave: 'veiculos', link: '/relatorio-geral', texto: 'Relatórios > Geral > Veículos' },
                    { chave: 'categoria', link: '/categoria', texto: 'Cadastros > Financeiro > Categorias' },
                    { chave: 'contrato', link: '/modelo-contrato', texto: 'Cadastros > Locação > Contrato' },
                    { chave: 'troca de óleo', link: '/troca-de-oleo', texto: 'Movimentos > Operacional > Troca de óleo' },
                    { chave: 'vistoria', link: '/vistoria', texto: 'Movimentos > Operacional > Vistoria' },
                  ].filter(item => podeAcessarRota(token, item.link))}
                />
              )}
            </HeaderLeft>

            <HeaderRight>
              {contaMenosDe30Dias && (
                <TourButton onClick={() => startTour('botao')}>
                  <FaRoute size={14} />
                  Primeiros Passos
                </TourButton>
              )}

              <TrainingButton data-tour="training-button" onClick={openTrainingPlaylist}>
                <FaVideo size={14} />
                Assistir Treinamento
              </TrainingButton>

              {locaSmartCheckIntegrado && (
                <TrainingButton onClick={() => history.push('/vistoria')}>
                  <img src={logoLocaSmartCheck} alt="" style={{ width: 16, height: 16, borderRadius: 3 }} />
                  Como usar o LocaSmartCheck?
                </TrainingButton>
              )}

              <AssistantHeaderButton onClick={() => window.dispatchEvent(new Event('open-help-bot'))}>
                <FaRobot size={14} />
                Assistente LocaSmartPro
              </AssistantHeaderButton>

              {ofertasVisiveis(token) && (
                <SeloOfertasBlackFriday onClick={() => window.dispatchEvent(new Event(EVENTO_ABRIR_OFERTAS))} />
              )}

              <BotaoImplantacao />

              <NotificationBell
                notifications={notifications}
                onClearAll={handleClearAllNotifications}
                isOpen={showNotifications}
                onToggle={setShowNotifications}
                onNotificationClick={(e: any) => {
                  const targetUrl = new URL(e.url, window.location.origin);
                  const currentPath = window.location.pathname;
                  const targetPath = targetUrl.pathname;

                  if (currentPath === targetPath) {
                    window.location.href = e.url;
                  } else {
                    history.push(e.url);
                  }
                }}
              />

              {isCadastroIncompleto && (
                <PulseButton onClick={() => history.push('/minha-conta')}>
                  Complete seu Cadastro
                </PulseButton>
              )}

              <AccountButton onClick={toggleAccountDropdown}>
                <div className="avatar">{getInitials(obterNomeUsuario(token))}</div>
                {!isMobile && (
                  <ArrowIcon isOpen={accountDropdownOpen}>
                    {accountDropdownOpen ? <IoIosArrowUp size={16} /> : <IoIosArrowDown size={16} />}
                  </ArrowIcon>
                )}
              </AccountButton>

              {accountDropdownOpen && (
                <AccountDropdown ref={accountDropdownRef}>
                  <div className="user-info">
                    <div className="name">{obterNomeUsuario(token)}</div>
                    <div className="document">Empresa: {obterNomeEmpresa(token).toUpperCase()}</div>
                  </div>
                  <div className="menu-item" onClick={() => history.push("/minha-conta")}>Minha conta</div>
                  <div className="menu-item" onClick={() => history.push("/minha-conta?aba=assinatura")}>Meu plano</div>
                  <div className="menu-item" onClick={() => history.push("/minha-conta?aba=configuracao")}>Configuração</div>
                  <div className="menu-item" onClick={() => history.push("/minha-conta?aba=integracao")}>Integrações</div>
                  <div className="menu-item" onClick={() => history.push("/termos-de-uso")}>Termos e Contratos</div>
                  <div className="menu-item" onClick={handleLogout}>Sair</div>
                </AccountDropdown>
              )}
            </HeaderRight>
          </Header>

          {emContingencia && !isFreePlan && !isTrial && (
            <ContingencyBanner>
              <div>
                <h5>⚠️ {faturasEmAtraso > 1 ? `Você tem ${faturasEmAtraso} faturas em atraso` : 'Fatura em atraso'}</h5>
                <span>
                  Sua conta será suspensa em {diasRestantesContingencia} dia{diasRestantesContingencia !== 1 ? 's' : ''}. Regularize agora para não perder o acesso.
                  {faturasEmAtraso > 1 ? ' O pagamento de uma fatura não quita as demais.' : ''}
                </span>
              </div>
              <ContingencyPayButton onClick={() => history.push('/renovar')}>
                Pagar agora
              </ContingencyPayButton>
            </ContingencyBanner>
          )}

          {(mostrarAvisos && (avisos.length > 0)) && (
            <NotificationBar isFreePlan={isFreePlan} ref={notificationRef}>
              <div>
                {avisos.map((aviso, index) => (
                  <div key={index}>{aviso}</div>
                ))}
              </div>
              <button onClick={fecharCentralAvisos}>×</button>
            </NotificationBar>
          )}

          <TabBar />

          <ContentWrapper mostrarAvisos={mostrarAvisos}>
            <AppDownloadAlert />
            {children}
          </ContentWrapper>
        </ContentContainer>
      </LayoutContainer>

      <OfertasBlackFriday token={token} telefoneEmpresa={telefoneEmpresa} pathname={location.pathname} />

      <OnboardingChecklist
        active={tourActive}
        origem={origemTour}
        onFinish={() => setTourActive(false)}
      />

      {activeGuideSteps && (
        <StepByStepGuide
          steps={activeGuideSteps}
          onComplete={handleGuideComplete}
          onDismiss={handleGuideDismiss}
        />
      )}

      <FloatingHelpBot />
      <AvatarAssistente />
      <BalaoProativo oculto={tourActive || !!activeGuideSteps} />
      </InsightsProvider>

    </ThemeProvider>
  );
}